export const UserRolesKey = {
  ADMIN: "admin",
  POWER_USER: "power_user",
  USER: "user",
  REDLINING_USER: "redlining_user",
  CLAUSE_CHECK_USER: "clause_check_user",
};

export const UserRoleTagLine = {
  [UserRolesKey.REDLINING_USER]: " Access Only Contract Redlining",
  [UserRolesKey.CLAUSE_CHECK_USER]: " Access only Clause Check",
  [UserRolesKey.ADMIN]: "Manages core contract operations",
  [UserRolesKey.POWER_USER]:
    "Oversees all modules and global platform controls",
  [UserRolesKey.USER]: "Access based on assigned modules",
};

export const PromptsForFeature = {
  CONTRACT_REVIEW_TAB: {
    CONTRACT_REVIEW_CLAUSE_CHECK_LIST: "contract_clause_check",
    CONTRACT_REVIEW_IMPORT_CLAUSE_CHECK_LIST:
      "contract_review_import_clause_check",
  },
  CLAUSE_CHECK_TAB: {
    CLAUSE_CHECK: "clause_check",
    GET_IMPORT_CLAUSE_CHECK_SUMMARY: "import_clause_check",
    CLAUSE_CHECK_VERTICAL_LIST: "clause_check_vertical_list",
    CLAUSE_CHECK_VERTICAL_ADVANCED_LIST: "clause_check_vertical_advanced_list",
    ENABLE_DISABLE_CHECK_VERTICAL_LIST:
      "enable_disable_clause_check_vertical_list",
    ADD_NEW_CLAUSE_CHECK: "add_new_clause",
  },
  TALK_TO_CONTRACT: "talk_to_contract",
  CONTRACT_REDLINING: "contract_redlining",
  CONTRACT_EXECUTION: "contract_execution",
  CONTRACT_EXPIRY: "contract_expiry",
};

export const PromptLabels = [
  {
    value:
      "Users can edit the threshold values pertaining to the rules for the below standard clauses.",
  },
  {
    value:
      "Configure Clause Checks. Add, import, or edit clauses, keywords, and validation rules for identifying clauses in contracts.",
  },
  {
    value:
      "Users can manage keywords and their synonyms utilized by the chatbot for document queries.",
  },
];

export const defaultClauseStatus = {
  NEW_KEYWORD: "new",
  DEFAULT: "default",
};

export const rulesAndThresholds: { [key: string]: any } = {
  "Committed Buffer": {
    rules: [
      {
        startString:
          "For Bench Pool, Staffing levels are adjustable, with at least ",
        endString:
          " of the required personnel available to maintain service continuity, would be kept in buffer in case of extra resource needed.",
      },
    ],
    threshold: [
      {
        key: "Staffing Size/Bench Pool:",
        value:
          "Minimum percentage of required personnel to maintain service continuity.",
      },
    ],
  },
  "Productivity Improvements": {
    rules: [
      {
        startString: "The contract should exceed a term of ",
        endString: "starting from the SOW Effective Date.",
      },
      {
        startString: "The floor for productivity improvements is ",
        endString:
          "which represents the minimum permissible percentage increase in productivity.",
      },
    ],
    threshold: [
      {
        key: "Contract Term:",
        value: "Minimum duration for the contract term.",
      },
      {
        key: "Productivity Improvement (%):",
        value: "Minimum permissible percentage increase in productivity",
      },
    ],
  },
  "SLA Penalty/Earn back": {
    rules: [
      {
        startString: "The Credit cap /Penalty should be minimum ",
        endString: "",
      },
    ],
    threshold: [
      {
        key: "Credit Cap/Penalty:",
        value: "Minimum percentage for the credit cap or penalty.",
      },
    ],
  },
  "Volume Discounts": {
    rules: [
      {
        startString: "The total spend must be at ",
        endString: "MTC.",
      },
      {
        startString: "The volume discount should be a minimum of ",
        endString: "",
      },
    ],
    threshold: [
      {
        key: "Total Discount:",
        value: "Minimum Percentage discount applied to the total spend (MTC).",
      },
      {
        key: "Total Spends:",
        value: "Minimum MTC value required to qualify for the discount.",
      },
    ],
  },
};

export const errorsForTTCClauseManagement = {
  WORD: {
    required: "Keword is required",
    duplicate: "keyword already exists",
  },
  SYNONYM: {
    minCharacters: "Synonym should be atleast 1 character",
    required: "Atleast one synonym is required",
    duplicate: "Synonym already exists for this keyword",
  },
};

export const defaultVisibleSynonymsNumber = 7;

export const adminClauseCheckConstants = {
  CONTRACT_REVIEW_CLAUSE_LIST: "CONTRACT_REVIEW_CLAUSE_LIST",
  CLAUSE_CHECK_LIST: "CLAUSE_CHECK_LIST",
  IMPORT_CLAUSE_CHECK_LIST: "IMPORT_CLAUSE_CHECK_LIST",
  IMPORT_CONTRACT_REVIEW_CLAUSE_CHECK_LIST:
    "IMPORT_CONTRACT_REVIEW_CLAUSE_CHECK_LIST",
};

export const DRIVE_FOLDER = {
  SRC: "src_drive_folder",
  DEST: "dest_drive_folder",
};
